export enum CommonRegexPatterns {
  BAD_CHARACTERS = '{}[]^"~%',
}
